module.exports = __webpack_public_path__ + "static/img/bg.06fcc5fa.jpg";